export default "__VITE_ASSET__BLw7Cz8___"